<template>
  <el-dialog
      title="Chuyển đổi dữ liệu nhận xét"
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      top="5vh"
  >
    <section v-loading="isLoading">
      <div class="migration-card">
        <div class="card-sub-title">
          <i class="el-icon-s-operation"></i> Thông tin chuyển đổi
        </div>

        <el-form
            ref="migrationForm"
            :model="form"
            :rules="rules"
            label-position="top"
            size="small"
        >
          <el-form-item label="Trường" prop="schoolId">
            <el-select
                v-model="form.schoolId"
                placeholder="Chọn trường"
                style="width: 100%"
                filterable
            >
              <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.id + ' - ' + item.schoolName"
              />
            </el-select>
          </el-form-item>

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="Loại nhận xét" prop="type">
                <el-radio-group v-model="form.type" @change="handleTypeChange">
                  <el-radio-button label="daily">Ngày</el-radio-button>
                  <el-radio-button label="weekly">Tuần</el-radio-button>
                  <el-radio-button label="monthly">Tháng</el-radio-button>
                  <el-radio-button label="periodic">Định kỳ</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="form.type === 'daily'" label="Tháng nhận xét" prop="selectedMonth">
                <el-date-picker
                    v-model="form.selectedMonth"
                    type="month"
                    placeholder="Chọn tháng"
                    format="MM/yyyy"
                    value-format="yyyy-MM"
                    style="width: 100%"
                />
              </el-form-item>
              <el-form-item v-else label="Năm nhận xét" prop="selectedYear">
                <el-date-picker
                    v-model="form.selectedYear"
                    type="year"
                    placeholder="Chọn năm"
                    format="yyyy"
                    value-format="yyyy"
                    style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>

        <div class="warning-note">
          <i class="el-icon-warning-outline"></i>
          <div class="warning-note-content">
            <div>Dữ liệu nhận xét mới đã tồn tại sẽ được bỏ qua, không ghi đè.</div>
            <div class="period-note" v-if="form.type === 'daily'">
              Chọn một tháng; hệ thống sẽ chuyển đổi từ ngày đầu đến ngày cuối tháng.
            </div>
            <div class="period-note" v-else>
              Chọn một năm; hệ thống sẽ chuyển đổi trong phạm vi cả năm.
            </div>
          </div>
        </div>
      </div>

      <div class="migration-card" v-if="result !== null">
        <div class="card-sub-title">
          <i class="el-icon-data-analysis"></i> Kết quả chuyển đổi
        </div>

        <div class="result-summary">
          <div class="summary-box total">
            <span class="num">{{ result.sourceCount }}</span>
            <span class="lbl">Tổng bản ghi</span>
          </div>
          <div class="summary-box skipped">
            <span class="num">{{ result.skippedCount }}</span>
            <span class="lbl">Bỏ qua ⏭️</span>
          </div>
          <div class="summary-box success">
            <span class="num">{{ result.insertedCount }}</span>
            <span class="lbl">Đã lưu ✅</span>
          </div>
          <div class="summary-box failed">
            <span class="num">{{ result.failedCount }}</span>
            <span class="lbl">Lỗi ❌</span>
          </div>
        </div>

        <div class="result-legend">
          <div class="legend-title">
            <i class="el-icon-info"></i>
            <span>Chú thích</span>
          </div>
          <div class="legend-item">
            <strong>Tổng bản ghi:</strong>
            tổng số bản ghi nhận xét tìm thấy theo trường và thời gian đã chọn.
          </div>
          <div class="legend-item">
            <strong>Đã lưu:</strong>
            số bản ghi đã chuyển đổi và lưu thành công vào dữ liệu mới.
          </div>
          <div class="legend-item">
            <strong>Bỏ qua:</strong>
            số bản ghi không được ghi thêm, thường do đã tồn tại hoặc không có nội dung nhận xét.
          </div>
          <div class="legend-item">
            <strong>Lỗi:</strong>
            số bản ghi chuyển đổi thất bại, cần kiểm tra lại để xử lý.
          </div>
        </div>
      </div>
    </section>

    <span slot="footer" class="dialog-footer">
      <el-button type="danger" size="medium" @click="closeDialog">
        <i class="el-icon-circle-close"/> Đóng
      </el-button>
      <el-button type="primary" size="medium" :loading="isLoading" @click="handleMigrate">
        <i class="el-icon-refresh"/> Chuyển đổi
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import EvaluationMigrationService from "@/services/AdminService/EvaluationMigrationService";

export default {
  name: "MigrationEvaluationDialog",
  props: {
    dialogVisible: { type: Boolean, default: false, required: true },
    schoolList: { type: Array, default: () => [] },
  },
  data() {
    const required = (message) => ({
      required: true,
      message,
      trigger: "change",
    });
    return {
      form: {
        schoolId: null,
        type: "daily",
        selectedMonth: null,
        selectedYear: null,
      },
      rules: {
        schoolId: [required("Vui lòng chọn trường")],
        type: [required("Vui lòng chọn loại nhận xét")],
        selectedMonth: [{ validator: this.validateSelectedMonth, trigger: "change" }],
        selectedYear: [{ validator: this.validateSelectedYear, trigger: "change" }],
      },
      result: null,
      isLoading: false,
    };
  },
  methods: {
    validateSelectedMonth(rule, value, callback) {
      if (this.form.type === "daily" && !value) {
        callback(new Error("Vui lòng chọn tháng nhận xét"));
      } else {
        callback();
      }
    },
    validateSelectedYear(rule, value, callback) {
      if (this.form.type !== "daily" && !value) {
        callback(new Error("Vui lòng chọn năm nhận xét"));
      } else {
        callback();
      }
    },
    handleTypeChange() {
      this.form.selectedMonth = null;
      this.form.selectedYear = null;
      this.result = null;
      this.$nextTick(() => this.$refs.migrationForm && this.$refs.migrationForm.clearValidate());
    },
    handleMigrate() {
      this.$refs.migrationForm.validate((valid) => {
        if (!valid) return;

        this.$confirm(
            "Dữ liệu nhận xét mới đã tồn tại sẽ được bỏ qua. Bạn có chắc chắn muốn chuyển đổi?",
            "Xác nhận chuyển đổi",
            { confirmButtonText: "Xác nhận", cancelButtonText: "Huỷ bỏ", type: "warning", closeOnClickModal: false }
        ).then(() => this.executeMigrate()).catch(() => {});
      });
    },
    async executeMigrate() {
      this.isLoading = true;
      this.result = null;
      try {
        const payload = this.buildMigrationPayload();
        let response;
        if (this.form.type === "monthly") {
          response = await EvaluationMigrationService.migrateMonthly(payload);
        } else {
          const method = {
            daily: "migrateDaily",
            weekly: "migrateWeekly",
            periodic: "migratePeriodic",
          }[this.form.type];
          response = await EvaluationMigrationService[method](payload);
        }

        this.result = response.data.data || {
          sourceCount: 0,
          insertedCount: 0,
          skippedCount: 0,
          failedCount: 0,
        };
        if (this.result.failedCount > 0) {
          this.$message({ message: "Có bản ghi lỗi, vui lòng kiểm tra lại", type: "warning" });
        } else {
          this.$message({ message: "Chuyển đổi dữ liệu nhận xét thành công", type: "success" });
        }
      } catch (err) {
        const msg = err?.response?.data?.message || "Có lỗi xảy ra khi chuyển đổi dữ liệu nhận xét";
        this.$message({ message: msg, type: "error" });
      } finally {
        this.isLoading = false;
      }
    },
    buildMigrationPayload() {
      const payload = { schoolId: this.form.schoolId };

      if (this.form.type === "daily") {
        const [year, month] = this.form.selectedMonth.split("-").map(Number);
        const lastDay = new Date(year, month, 0).getDate();
        payload.fromDate = this.formatDate(year, month, 1);
        payload.toDate = this.formatDate(year, month, lastDay);
        return payload;
      }

      const year = this.form.selectedYear;
      if (this.form.type === "monthly") {
        payload.fromMonth = `${year}-01`;
        payload.toMonth = `${year}-12`;
      } else {
        payload.fromDate = `${year}-01-01`;
        payload.toDate = `${year}-12-31`;
      }
      return payload;
    },
    formatDate(year, month, day) {
      return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    },
    closeDialog() {
      this.result = null;
      this.form.schoolId = null;
      this.form.type = "daily";
      this.form.selectedMonth = null;
      this.form.selectedYear = null;
      this.$refs.migrationForm && this.$refs.migrationForm.resetFields();
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.migration-card {
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #eef2f6;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
  margin-bottom: 16px;
}

.card-sub-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e3a8a;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.warning-note {
  margin-top: 16px;
  padding: 10px 14px;
  background-color: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
  font-size: 13px;
  color: #92400e;
  display: flex;
  align-items: center;
  gap: 8px;

  i { font-size: 16px; color: #d97706; }

  .warning-note-content { flex: 1; }
  .period-note { margin-top: 4px; }
}

.result-summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;

  .summary-box {
    padding: 14px 12px;
    border-radius: 10px;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 4px;

    &.total { background-color: #f0f9ff; border: 1px solid #bae6fd; .num { color: #0369a1; } }
    &.success { background-color: #f0fdf4; border: 1px solid #bbf7d0; .num { color: #166534; } }
    &.skipped { background-color: #fffbeb; border: 1px solid #fde68a; .num { color: #92400e; } }
    &.failed { background-color: #fef2f2; border: 1px solid #fecaca; .num { color: #991b1b; } }

    .num { font-size: 22px; font-weight: 700; }
    .lbl { font-size: 12px; color: #64748b; }
  }
}

.result-legend {
  margin-top: 16px;
  padding: 12px 14px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #475569;
  font-size: 12px;
  line-height: 1.5;

  .legend-title {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
    color: #334155;
    font-size: 13px;
    font-weight: 600;

    i { color: #2563eb; }
  }

  .legend-item { margin-top: 3px; }
  strong { color: #334155; }
}

::v-deep .el-dialog { border-radius: 16px; overflow: hidden; }
::v-deep .el-dialog__header { background: linear-gradient(135deg, #2563eb, #1d4ed8); padding: 18px 24px !important; }
::v-deep .el-dialog__title { color: white !important; font-size: 19px !important; font-weight: 600; }
::v-deep .el-dialog__headerbtn .el-dialog__close { color: white !important; font-size: 22px; }
::v-deep .el-dialog__body { max-height: 74vh; overflow-y: auto; background: #f8fafc; padding: 20px 24px !important; }
::v-deep .el-dialog__footer { background: #f1f5f9; padding: 14px 24px !important; border-top: 1px solid #e2e8f0; }
</style>
